<template>
  <LoginEmailConfirmContent
    :sign-in-to="vaSignInTo"
    :fallback-to="vaFallbackTo"
  />
</template>

<script lang="ts" setup>
import LoginEmailConfirmContent from './LoginEmailConfirmContent.vue';

const vaSignInTo = { name: 'VaAppSignin' };
const vaFallbackTo = { name: 'VaCallList' };
</script>
